import { redirect, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/store/buy-gold-coins')({
  beforeLoad: async ({ search, location }) => {
    search.store = 'buy-gold-coins'
    throw redirect({
      to: '/',
      search,
      state: location.state,
    })
  },
})
